const zh = {
  //Header
  logoDescription: "概念水烟俱乐部",

  //Menu
  home: "主页",
  menu: "菜单",
  reservation: "预订",
  faq: "常见问题",

  //Profile
  firstNameLabel: "名字",
  firstNamePlaceholder: "请输入名字",
  nicknameLabel: "昵称",
  phoneLabel: "电话号码",
  phonePlaceholder: "+7 (___) ___-__-__",
  languageLabel: "语言",
  save: "保存",
  saving: "保存",
  saved: "已保存",
  language: "介面語言",
  visitHistoryTitle: "到访记录",
  visitHistoryLoading: "正在加载...",
  visitHistoryEmpty: "暂无到访记录。",
  visitHistoryError: "无法加载记录",
  visitTime: "时间",
  visitGuests: "人数",
  visitDuration: "时长",
  visitHoursShort: "小时",
  visitMinutesShort: "分钟",

  //Home
  details: "详情",
  comingSoon: "敬请期待",

  reserveTitle: "预订",
  reserveSubtitle: "现在",

  menuTitle: "菜单",

  residence: "会所",
  parking: "停车",
  spaces: "空间",

  albumsTitle: "相册",
  albumsSubtitle: "与瞬间",

  contactsTitle: "联系方式",
  contactsSubtitle: "与信息",

  writeTitle: "留言",
  writeSubtitle: "给经理",

  artifactsTitle: "藏品",
  cateringTitle: "餐饮服务",
  merchTitle: "周边",

  altMenu: "菜单",

  hookahLunch: "水烟午餐",
  vinylRoom: "黑胶房",
  radiolaRoom: "留声机房",
  veranda: "露台",
  studio54: "STUDIO 54",

  //Reservation
  title: "预订",

  bookingNameLabel: "预订姓名",
  bookingNameRequired: "请输入姓名",
  bookingNameInvalidError: "请输入姓名",
  bookingNameFormatError: "仅限字母",
  bookingNamePlaceholder: "例如：Ivan",

  phoneLabelReservation: "电话号码",
  phoneRequired: "请输入电话号码",

  dateLabel: "选择日期",
  dateFormatError: "格式 DD.MM.YYYY",
  dateInvalidError: "日期无效",
  dateClosedError: "休息日",

  guestsLabel: "人数",
  guestsRequired: "请输入人数",
  guestsPlaceholder: "例如：3",
  guestsRangeError: "1 到 999 位客人",

  timeLabel: "到店时间",
  timeRequired: "请输入到店时间",
  timePlaceholderPrefix: "例如：",
  timeFormatError: "格式 HH:MM",
  timeInvalidError: "时间无效",
  timeNotWorkingError: "非营业时间",

  durationLabel: "时长",
  durationRequired: "请选择时长",
  durationDefaultError: "1 到 24 小时",
  durationSecretError: "1 到 10 小时",
  durationStepError: "步长 30 分钟",

  duration_1h: "1 小时",
  duration_1_5h: "1.5 小时",
  duration_2h: "2 小时",
  duration_2_5h: "2.5 小时",
  duration_3h: "3 小时",
  duration_3_5h: "3.5 小时",
  duration_4plus: "4 小时及以上",

  roomLabel: "房间",
  roomPlaceholder: "房间",

  commentLabel: "附加备注",
  commentPlaceholder: "可选",
  commentHint: "(P.S. 露台预订仅限当天，从 12:00 起)",

  submit: "预订",
  submitting: "正在预订...",
  success: "申请已发送",
  submitError: "发送申请失败，请稍后再试。",

  reservationHour: "小時",
  reservationHour2: "小時",

  //Parking
  parkingTitle: "停车",
  guestParkingHeadline: "为方便您，Residence 提供访客停车位",
  howItWorksP1:
    "使用方式：请先以任意方便的方式在 Residence 预订餐桌（预订当日均可驶入）。如果同行客人也自驾前往，我们可应请求发送车辆登记链接（您的同伴只需留下姓名和电话）。",
  howItWorksP2:
    "然后前往“达恰·加舵克”咖啡馆（多尔戈鲁科夫斯卡娅街 31 号，32 栋），在其建筑前右转，会看到两个道闸（左、右）。请走左侧道闸。",
  barrierPhoneLabel: "当您已到达该道闸时，只需拨打我们的专用号码：",
  howItWorksP3: "完成：您可以停在任何空余车位。",
  howItWorksP4: "离场同样通过拨打该号码。",
  parkingWalkDistance: "Residence 距离停车场步行约三分钟。",
  parkingNotesTitle: "两点重要说明：",
  parkingNote1: "1）我们的停车场仅限前往 Residence 的客人使用；",
  parkingNote2: "2）停车场不对共享汽车开放。",
  parkingThanks: "感谢您的理解！期待您的到访！",
  buildRouteButton: "规划到停车场路线",
  yandexAriaLabel:
    "在 Yandex 地图中前往：莫斯科，多尔戈鲁科夫斯卡娅街 31 号（32 栋）的路线",
  yandexTitle: "在 Yandex 地图中规划路线",
  parkingVideo: "進入停車場的影片",

  //SendSms
  infoText: "留下消息/建议/反馈。负责人会尽快与您联系。",
  placeholder: "给负责人的留言",
  alreadySentError: "已发送。请等待回复。",
  sendFailError: "发送失败。请再试一次。",
  sentStatus: "消息已发送。",

  //Albums
  titleAlbums: "相簿",
  titleAlbum: "相簿:",
  download: "下載",

  //Contacts
  ContactsTitle: "联系方式",
  mapTitle: "Yandex 地图",

  workingHoursTitle: "营业时间：",
  workingHoursSunThu: "周日-周四 12:00-02:00",
  workingHoursFriSat: "周五-周六 12:00-04:00",
  workingHoursHolidayNote: "节假日期间营业时间可能会调整",

  addressTitle: "地址：",
  addressLine: "俄罗斯莫斯科 多尔戈鲁科夫斯卡娅街25号 1号楼",
  entranceHint: "入口就在多尔戈鲁科夫斯卡娅街：大木门和对讲门禁",
  entrancePhotoLink: "（示意照片）",

  residencePhonesTitle: "会所电话：",

  ParkingTitle: "停车",
  parkingHowToGetThere: "如何到达",
  parkingOpenBarrier: "开闸电话：",

  wifiTitle: "Wi-Fi：",
  wifiNameLabel: "网络名称：",
  wifiPasswordLabel: "密码：",

  socialNetworksTitle: "社交媒体：",

  writeToDirector: "给负责人发消息",
  leaveReviewYandex: "在Yandex上留下评价",

  entrancePhotoAlt: "会所入口",

  //Residence
  navResidence: "穆谢公馆",
  navHistory: "建筑历史",
  navLegend: "勒·卡良先生的传说",
  navRules: "规则",

  videoUnsupported: "您的浏览器不支持 HTML5 视频。",

  residenceTitle: "穆谢公馆",
  residenceP1: "一间以包豪斯风格打造的概念水烟俱乐部——有灵魂、有历史、有质感。",
  residenceP2:
    "我们是真正热爱二十世纪下半叶室内美学的人。更准确地说，公馆在审美与氛围上代表着 70、80 年代的黄金时代：兼收并蓄的复古风格，强调包豪斯元素，搭配大量极其舒适且优雅的家具，主要来自斯堪的纳维亚与中欧。我们的家具、灯具与装饰历时 3.5 年一点点搜集、寻找并运回，因为我们坚持“真品”，而非复制品。不过，公馆的室内（就像穆谢的所有项目一样）是“活的”，始终处于持续变化中：会不定期加入并丰富各种奇妙的小物件。",
  residenceP3:
    "顺带一提，你能看到的几乎所有设备都是模拟设备，而且全部可正常使用，并非摆设。比如，我们收藏有经典“软盘” Macintosh、极其罕见的 Sharp 10P-35（内置电视的磁带机/收录机）、“黑胶房”里的 Pioneer PL-780 黑胶系统、“留声机房”里精细复原的 Rigonda 组合音响，以及多台 Sanyo 与 Bang & Olufsen 的复古电视等。至于“隐藏”的部分——也就是“墙体内部”的技术系统——我们则按照当下的技术进步与“智能化”趋势进行选型与集成。仅通风系统就足够震撼：那是一个完整的工程级复杂项目，由俄罗斯顶尖团队花了足足 5 个月完成。",
  residenceP4:
    "我们非常喜欢真实植物，所以公馆里有很多绿植，得到充分照料，甚至还布置了一个小温室。烛台、经典桌游、给四脚朋友准备的垫子与食碗、灭火器，以及许许多多细节，都被我们极其认真地寻找与挑选——几乎每一处小细节都不放过。",
  residenceP5:
    "我们由衷自豪：十九世纪上半叶的老宅，与二十世纪下半叶欧洲家庭的陈设风格结合得如此自然。一个时代的立面气度，与另一个时代的精致光泽相互成就。",

  historyTitle: "建筑历史",
  historyP1:
    "“穆谢公馆”坐落于一座 1821 年建成并全面修复的老宅中。它最初是国家顾问安德烈·亚历山德罗维奇·彼得罗沃-索洛沃沃庄园的主宅。后来几度易主，其中包括玛丽亚·亚历山德罗芙娜·席勒——据传说，她正是勒·卡良先生的熟识之人。他们曾多次在这里以茶会友、畅谈甚欢：他讲述自己的旅程，也常带来点心与各类“神器/遗物”作为友好的礼物。",
  historyP2:
    "2019 至 2022 年间，我们的建筑经历了一次早已迫切需要的全面大修（毕竟它已屹立 200 年）。它保留了历史外观，同时在技术与结构层面进行了大幅加固与重建。再加上我们后续大量的补充工作（包括修复），如今整体状态非常出色。我们细致保留并修复了灰泥装饰、木门木窗、大客厅与小客厅的拼花地板，并引入了相当数量的辅助系统与智能系统。总之，我们尽最大努力一方面保留其精神与气度，另一方面让它尽可能现代化、周到且舒适——既适合宾客，也适合日常运营。",
  historyP3:
    "室内有一种非常独特的氛围，很大程度来自空间本身的建筑语言：灰泥线脚、高挑天花、壁炉、拼花地板、木窗与木门。光线与空气充足，并带着一种克制而 интеллигент 的基调。",
  historyP4:
    "这里有客厅、“私密”房间、几间小型“体验房”、一个大的夏季露台等等。我们有两层楼，而且两层在情绪与气质上各不相同。",
  historyP5:
    "另一个值得骄傲的点，是所有工作区域的布置。是的，只有其中一处对外可见（水烟师的工作区），但我们保证其他区域同样井然有序、人体工学非常出色。",
  historyP6:
    "总之，这是一条漫长的路——细致、扎实、复杂——但结果值得！一切为了你们，也为了我们大家一起，朋友们！",

  legendTitle: "勒·卡良先生的传说",
  legendP1:
    "没有人能确切说出勒·卡良先生生于何处、活在何时。有人认为他是英国人，向旧大陆供应阿拉伯商品；也有人坚持他是西藏僧侣，为了内在和谐而吸水烟，热衷研究不同的装填方式，并活到了 150 岁。还有人说他是法国人，与拿破仑私交甚笃，甚至偶尔会一起抽水烟、讨论“世界计划”。另有一种说法认为他曾生活在俄罗斯，想在贵族圈里推广水烟风潮，却被革命打断。",
  legendP2:
    "无论如何，关于他是否真实存在，并没有任何学术著作或历史考证。他不是伟大的统帅、征服者，也不是亨利·福特。但他确实是一位真正的水烟爱好者，倡导人们学会正确、轻松地制作水烟，享受明亮的香气与浓厚的烟雾。我们非常珍视这种冲动，并会努力让他的理念继续延续。",

  rulesTitle: "公馆规则",
  rulesIntro: "为了让您的休息尽可能高质量、只带来积极体验，我们有几条规则：",
  rulesLi1: "请勿使用粗俗或不雅用语。",
  rulesLi2: "公馆仅接待成年宾客。",
  rulesLi3: "仅限在清醒状态下入内。",
  rulesLi4: "店内不吸香烟、IQOS 与电子烟。",
  rulesLi5: "禁止自带饮料与酒精。",
  rulesLi6: "本店为专业水烟俱乐部，默认需点一支水烟。",
  rulesOutro: "感谢理解，祝您度过美好时光！",

  altInterior: "室内",
  altTechnique: "设备",
  altPlantsDetails: "植物与细节",
  altResidenceHistory: "公馆历史",
  altHistory: "历史",

  //Rooms
  headerTitle: "私密房间与空间",

  sacredRoomsTitle: "私密房间：",
  rentSpacesTitle: "空间租赁：",

  vinylRoomName: "黑胶房",
  vinylRoomDesc: "独立房间，配黑胶唱机、出色音响和大量唱片收藏",

  radiolaRoomName: "留声机房",
  radiolaRoomDesc: "独立房间，配留声机系统与专属迷你影院",

  smallLivingRoomName: "小客厅",
  smallLivingRoomDesc: "宽敞、舒适又好看——最多可容纳 15 人",

  discoHallName: "Disco Polaroid 大厅",
  discoHallDesc: "70 年代风格的大空间，致敬 Studio 54——最多可容纳 30 人",

  bigLivingRoomName: "大客厅",
  bigLivingRoomDesc: "宽敞、精致，带壁炉——最多可容纳 20 人",

  wholeResidenceName: "整栋公馆",
  wholeResidenceDesc: "两层 +（暖季）露台。独家方案，价格较高",

  detailsButton: "详情",

  faqSecretRoomsTitle: "「私密房间」FAQ：",
  faqRentSpacesTitle: "「空间租赁」FAQ：",

  faqPageRooms: {
    questions: [
      {
        id: 2,
        title: "可以在「私密房间」里自行使用设备吗？",
        answer:
          "当然可以（甚至非常欢迎）。我们的工作人员会告诉你哪些设备如何使用。部分设备还配有定制的、直观的使用说明。",
      },
      {
        id: 3,
        title: "可以在哪里观看自己的内容吗？",
        answer:
          "可以。在「留声机房（Radiola Room）」你可以用一台很棒的投影仪观看任何内容（电影、演唱会、节目、YouTube、演示文稿等），并且是最高画质，配合优秀的 5.1 环绕声。\n\n另外，两间「私密房间」各配有一台复古电视——我们为它们集成了联网功能，所以也可以同样观看你自己的或想看的任何内容。\n\n我们的工作人员会带你操作并讲解使用方法。",
      },
      {
        id: 4,
        title: "在「私密房间」里音乐可以放多大声？",
        answer: "随你喜欢 :)",
      },
      {
        id: 5,
        title: "「私密房间」适合商务会面吗？",
        answer:
          "非常适合——既适合商务，也适合朋友聚会。在「留声机房（Radiola Room）」还可以使用投影仪播放演示文稿或进行视频通话。无论如何，你都会在独立房间里，这也常常是保密交流所需要的。\n\n「私密房间」也非常适合约会，或者一个人安静休息（有时候这非常有用）。",
      },
      {
        id: 6,
        title: "租用某个空间时，可以自带食物和饮料/酒精吗？",
        answer:
          "食物可以放心自带（例如 заказать кейтерing）。但饮料和酒精只能点我们菜单上的。选择很多，口味也很全。",
      },
      {
        id: 7,
        title: "租用哪些空间时可以播放自己的音乐？",
        answer:
          "当你整厅租用「Disco Polaroid」大厅时可以（唯一 просьба：尽量符合我们的 концепт），以及整栋租用公馆时也可以——这种情况下音乐完全不限。",
      },
      {
        id: 8,
        title: "租用空间需要预付款吗？",
        answer:
          "视空间而定。租用小客厅不需要预付款；租用大客厅或「Disco Polaroid」大厅需要 20% 预付款；整栋租用公馆则为：全天租用预付款 50%，非全天租用预付款 30%。",
      },
      {
        id: 9,
        title: "可以邀请你们的摄影师参加活动吗？",
        answer:
          "可以。当然没问题。我们会把你和 Stepan 对接，你们可以讨论所有细节和价格。",
      },
      {
        id: 10,
        title: "整厅租用「Disco Polaroid」大厅时可以进入露台吗？",
        answer: "很遗憾不可以，因为我们出租这个大厅的时间段露台不开放。",
      },
      {
        id: 11,
        title: "不租用单独空间的情况下，可以大团体来吗？",
        answer:
          "这要看团体有多大 :) 我们有：\n- 几张大桌，可容纳 5–7 人；\n- 「私密房间」： 「黑胶房（Vinyl Room）」5–7 人，「留声机房（Radiola Room）」4–6 人；每间 1500 卢布/小时，不分时间和星期几，不设最低消费；\n- 在「Disco Polaroid」大厅把两张大桌合并为 8–12 人（不租大厅，但有最低消费）：\n6000 卢布/小时（周一–周五 12:00–19:00，周一–周四与周日 00:00–02:00，周五–周六 01:00–04:00，周六–周日 12:00–14:00）\n以及\n9000 卢布/小时（周一–周四 19:00–00:00，周五 19:00–01:00，周六 14:00–01:00，周日 14:00–00:00）；\n- 露台两种拼桌方案：6–8 人不租用且无最低消费 + 9–12 人不租用但有最低消费：\n7000 卢布/小时（周一–周五 12:00–19:00，周一–周四与周日 00:00–02:00，周五–周六 01:00–04:00，周六–周日 12:00–14:00）\n以及\n10000 卢布/小时（周一–周四 19:00–00:00，周五 19:00–01:00，周六 14:00–01:00，周日 14:00–00:00）。\n\n8 人以上的公司会加收 10% 服务费。",
      },
      {
        id: 12,
        title: "可以额外布置/装饰租用的空间以匹配活动主题吗？",
        answer:
          "可以。租用小客厅或大客厅可以做“轻量”装饰；整厅租用「Disco Polaroid」大厅可以做更“进阶”的布置；而对既有 интерьер 做 серьёзные、существенные 改动，只能在整栋租用公馆时进行。",
      },
      {
        id: 13,
        title: "可以以公司名义对公转账并签订租赁合同吗？",
        answer: "可以，两种方式都可以，按你方便的来。",
      },
    ],
  },

  //FAQ
  faqPage: {
    title: "常见问题",
    questions: [
      {
        id: 8,
        title: "可以带狗来吗？",
        answer: `我们非常喜欢狗，也欢迎您带狗来本店。我们提供饮水碗和专用的防水垫毯。

但我们的首要目标是让所有客人都舒适，因此有几条简单规则：

1）很遗憾我们只能接待小型犬（肩高不超过 40 cm）；
2）希望狗狗安静、有礼貌：不要大声吠叫，并尽量待在主人身边；
3）我们有防水垫毯，但脏爪子仍然是问题。因此店内常备无酒精、低致敏的宠物湿巾；
4）店内没有专门的宠物如厕区，请您来之前先带狗狗充分散步。

感谢理解——也向我们的大小朋友们致以爱意！`,
      },
      {
        id: 9,
        title: "白天在这里办公方便吗？",
        answer: `非常方便！白天适合用笔记本工作：网络稳定、氛围安静、桌子舒适，并且每张桌子都有插座。

工作日白天很多客人会来办公——我们也准备了可移动的电脑侧桌，您提出需求我们就会为您拿来。

另外，工作日 12:00–17:00 有“水烟午餐”（经典水烟 2400 卢布）。`,
      },
      {
        id: 10,
        title: "可以自带饮料或食物吗？",
        answer:
          "很遗憾，不允许自带饮料（包括酒精）。食物可以自带，也可以通过任何外卖平台点餐。请尽量选择气味不重的食物，以免影响邻桌客人。感谢理解！",
      },
      {
        id: 11,
        title: "哪些证件可以证明 18+？",
        answer: `可用于证明年龄的证件：

- 俄罗斯国内护照
- 俄罗斯国际护照
- 临时身份证明（俄罗斯联邦）
- 海员证
- 俄罗斯外交护照
- 俄罗斯公务护照
- 军人证件/军人身份证或军人证
- 外国公民的外交/公务/普通护照
- 在俄无国籍人士居留许可
- 在俄无国籍人士临时居留许可
- 难民证
- 在俄临时庇护证明
- 驾驶证

不能用于证明年龄的材料：

- “Gosuslugi（政务服务）”App 内展示的任何文件
- 学生证
- 证件复印件或证件照片`,
      },
      {
        id: 12,
        title: "这里有 PlayStation 或 Xbox 吗？",
        answer: `没有游戏主机。但我们有非常棒的黑胶唱机（Vinyl Room），还有收音留声机与现代投影仪（Radiola Room），两个房间里都有复古电视，播放精选的 20 世纪内容。

小客厅里还有一个“小游戏房”，配有大型街机，可供所有客人使用。`,
      },
      {
        id: 13,
        title: "可以带未成年人一起来吗？",
        answer:
          "不可以，即使由父母、兄弟姐妹或任何法定监护人陪同也不行。本店仅接待 18+ 客人。",
      },
      {
        id: 14,
        title: "可以抽电子烟、IQOS 等吗？",
        answer: "不可以。电子烟、加热烟弹等设备禁止使用——只允许水烟 🙂",
      },
      {
        id: 15,
        title: "不点水烟也可以来休息吗？",
        answer: `“Musie Residence” 是一家专门的水烟俱乐部。此类场所通常 подразумевает（默认）水烟。有时同桌只有部分客人抽水烟也完全没问题，我们有高质量通风系统。

如果不抽水烟，您可以选择我们的私密包间（Radiola Room 或 Vinyl Room），但此时包间租金为 3000 卢布/小时。`,
      },
      {
        id: 16,
        title: "可以在这里拍照或进行专业拍摄吗？",
        answer: ({ Link }) => (
          <>
            在本店当然可以拍照和录视频，最重要的是不要影响其他客人。
            {"\n\n"}
            专业拍摄取决于形式。如果您计划摄影或专业视频拍摄，可以{" "}
            <Link
              to="/send-sms"
              style={{
                color: "#366091",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              给店长发消息
            </Link>{" "}
            ——他会根据您的需求提供更准确的说明。
          </>
        ),
      },
      {
        id: 17,
        title: "这里可以玩扑克吗？",
        answer:
          "不可以。我们必须明确说明：任何形式的扑克都不允许，即使不下注也不行。",
      },
    ],
  },

  //Rooms
  roomNames: {
    vinil: "黑胶房",
    radiola: "留声机房",
    livingrm: "小客厅（整厅）",
    disco: "Discopolaroid 大厅（整厅）",
    bigliving: "大客厅（整厅）",
    residence: "整栋公馆",
  },

  roomNames2: {
    vinil: "黑胶房",
    radiola: "留声机房",
    livingrm: "小客厅（整厅）",
    disco: "Discopolaroid 大厅（整厅）",
    bigliving: "大客厅（整厅）",
    residence: "整栋公馆",
  },

  ariaPrevPhoto: "上一张",
  ariaNextPhoto: "下一张",

  pricePerHourLabel: "每小时价格",
  pricePerHourValue: "1500 卢布",

  wifiLabel: "Wi-Fi：",
  passwordLabel: "密码：",

  sendRequestPrefix: "发送申请：",

  bookingNameError: "请输入姓名",
  phoneError: "请输入手机号",

  guestsOnlyDigitsError: "只能输入数字",
  guestsError: "请输入人数",

  timeError: "请输入到店时间",

  durationErrorText: "1 到 24 小时",
  durationError: "请输入时长",
  durationPlaceholder: "请输入时长（小时）",

  descriptionRequiredError: "请填写说明",
  descriptionLabel: "补充备注",
  descriptionPlaceholder: "填写活动的重要细节",

  sending: "发送中...",
  sent: "已发送",
  send: "发送",

  bookPrefix: "预订",

  vinil: [
    <>
      <b>「黑胶房」</b>
      是一间独立房间，让你仿佛穿越时空——沉浸在私密安静的氛围里，
      享受出色的声音、纯粹的模拟质感、唱针划过唱片的细微沙沙声，以及 VHS 录像带
      特有的“视觉噪点”。
      <br />
      <br />
      这里配有{" "}
      <b>复古黑胶唱机 Pioneer PL-780，并搭配著名的日本功放 Marantz SR4400</b>
      。唱片播放过程是全自动的，甚至支持重复播放！声音表现非常棒。此外，「黑胶房」还拥有{" "}
      <b>全墙面高品质隔音</b>——音量想开多大都不用拘束 :)
      <br />
      <br />
      如果你更想要“按下播放键”的触感体验：电影、剧集、电视节目或音乐录像，这里还有丹麦
      90 年代经典组合：<b>Bang &amp; Olufsen 电视机与录像机（VCR）</b>，
      在当年就是稀有设备，如今依然难得一见。
      <br />
      <br />
      第一次来到「黑胶房」时，我们一定会现场演示并讲解：怎么打开设备、以及如何使用这些器材。
      <br />
      <br />
      无论听黑胶还是看录像，在「黑胶房」你都可以使用一套{" "}
      <b>非常丰富的黑胶唱片收藏</b>（约 300 张：从经典到现代流行），以及{" "}
      <b>VHS 录像带和一台主机，收录了二十世纪下半叶最精彩的影像内容</b>。
      而且如果你愿意，这台电视也能播放任何你想看的内容——它连接到专用网络 :)
      <br />
      <br />
      <b>「黑胶房」舒适容纳 4–5 人；6–7 人会稍微紧凑一些，但依然很舒服。</b>
    </>,
  ],

  radiola: [
    <>
      我们认为，与复古设备那种可触可感的“模拟感”互动，会带来一种特别的舒适与乐趣。
      <br />
      <br />
      <b>「留声机房」</b>是一间独立房间，它会在多个维度同时带来这种体验：
      <br />
      <br />
      <b>先说模拟声音</b>
      ：留声机/收音组合的黄金时代在二十世纪中期——当时大体积的电子管收音机箱体，很容易与黑胶唱机合并在一起。
      <br />
      <br />
      因此，我们这台<b>精心修复的 Rigonda 复古留声机（Radiola）</b>
      ，既是对那个年代的小小致敬，也是这间「私密房间」的重要元素——它也正是房间名字的来源。
      设备完全可用，可以播放小尺寸唱片，为房间带来声音（我们准备了一套精致的小型唱片收藏）。此外，它本身也非常好看——作为“技术型装饰品”，为房间定下基调。
      <br />
      <br />
      <b>视觉体验方面，这里有：</b>
      <br />
      <br />
      第一台是经典 Sanyo 电视——保存状态极佳，是当年日本三大厂牌之一的代表作。
      和「黑胶房」的电视一样，我们通过专用机顶盒，尽量复刻了复古电视的感觉：广告、电影、节目和那个年代的
      MV，看起来非常有意思。
      当然，如果你愿意，这台电视也能播放任何你想看的内容——它同样连接到专用网络
      :)
      <br />
      <br />
      第二个是现代设备：一台<b>超短焦激光投影仪</b>
      ，几乎什么都能看——电影、演唱会、剧集、YouTube、工作演示都可以。
      即使在大晴天画面也很棒，并且配有调校到位的 5.1 音响。总之，这是一个{" "}
      <b>属于你的、紧凑但功能完整的私人影院</b> :)
      <br />
      <br />
      最后，为了把舒适度拉满，这里还有一张惊艳的{" "}
      <b>80 年代丹麦「Stressless」沙发（每个座位都可独立调节靠背角度）</b>。
      <br />
      <br />
      这种感觉很难用文字说清——更适合亲自体验 :)
      <br />
      <br />
      <b>「留声机房」舒适容纳 4 人；5–6 人会稍微紧凑一些，但依然很舒服。</b>
    </>,
  ],

  livingrm: [
    <>
      <b>「小客厅」</b>
      是很多客人最喜欢的空间：有壁炉、钢琴和大窗户，白天阳光会非常漂亮地洒进来。
      <br />
      <br />
      平时这里摆放 2
      张桌子，但也可以整厅租用：我们会带来额外家具，并且可以为自助/小型宴会布置
      2–3 张高脚鸡尾酒桌。照片里展示了一个布置示例。
      <br />
      <br />
      我们<b>随时可以提前接受预点</b>
      （菜单任意品项），这样你到达时，一切都已准备好并在小客厅等待你。
      <br />
      <br />
      可以自带食物（例如外卖或餐饮服务），但不允许自带酒精和任何饮料。
      <br />
      <br />
      <b>整厅租用时，小客厅的最佳容量为最多 15 人。</b>
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>费用由“租金 + 最低消费（押金）”组成：</b>
    </>,
    <>
      - 租金：任意星期、任意时间均为 1500 卢布/小时；
      <br />
      - 最低消费（押金）按以下规则计算：
      <br />
      <br />
      <i>周一–周四，12:00–19:00 与 00:00–02:00：7000 卢布/小时；</i>
      <br />
      <i>周一–周四，19:00–00:00：10000 卢布/小时；</i>
      <br />
      <br />
      <i>周五，12:00–19:00：7000 卢布/小时；</i>
      <br />
      <i>周五，19:00–01:00：15000 卢布/小时；</i>
      <br />
      <i>周五，01:00–04:00：9000 卢布/小时；</i>
      <br />
      <br />
      <i>周六，12:00–18:00 与 01:00–04:00：9000 卢布/小时；</i>
      <br />
      <i>周六，18:00–01:00：15000 卢布/小时；</i>
      <br />
      <br />
      <i>周日，12:00–18:00 与 00:00–02:00：8000 卢布/小时；</i>
      <br />
      <i>周日，18:00–00:00：12000 卢布/小时。</i>
      <br />
      <br />
      最低消费（以及超出最低消费的账单部分）将收取 10% 服务费。
      <br />
      <br />
      无需预付款。
    </>,
  ],

  disco: [
    <>
      <b>「Discopolaroid 大厅」</b>是一间充满 70–80 年代气息的大空间，明显致敬
      Studio 54 时代——可以说是那段“黄金俱乐部年代”的氛围。
      <br />
      <br />
      这里有一个很大的镜面迪斯科球（可开启旋转）以及大量同风格元素。镜框里的
      Disco Stu 我们尤其喜欢 :) 大厅的情绪也来自我们的定制水烟 “Studio
      54”，它早已成为公馆内部的一颗“明星”。
      此外，架子、柜子、窗台上还摆着一套相当独特、可正常使用的「拍立得」收藏——我们也很珍惜它的模拟感和成片的独特魔力。
      还有一个小型温室（同样带着 disco 元素！）。
      <br />
      <br />
      平时大厅内摆放 8
      张桌子，但也可整厅租用：我们会拼桌，必要时补充家具，安排一个小舞池（如需要），还可以提供不错的演出音箱（带低音炮）和
      DJ 台（不含 DJ 控制台/调音台）。 照片里展示了一个布置示例。
      <br />
      <br />
      我们<b>随时可以提前接受预点</b>
      （菜单任意品项），这样你到达时，一切都已准备好并在大厅等待你。
      <br />
      <br />
      可以自带食物（例如外卖或餐饮服务），但不允许自带酒精和任何饮料。
      <br />
      <br />
      <b>整厅租用时，「Discopolaroid 大厅」的最佳容量为最多 30 人。</b>
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>费用由“租金 + 最低消费（押金）”组成：</b>
    </>,
    <>
      - 租金按以下规则计算：
      <br />
      <br />
      <i>周一–周四，12:00–18:00 与 00:00–02:00：10000 卢布/小时；</i>
      <br />
      <i>周一–周三，18:00–00:00：15000 卢布/小时；</i>
      <br />
      <i>周四，18:00–00:00：20000 卢布/小时；</i>
      <br />
      <br />
      <i>周五，12:00–18:00：15000 卢布/小时；</i>
      <br />
      <i>周五，18:00–01:00：30000 卢布/小时；</i>
      <br />
      <i>周五，01:00–04:00：15000 卢布/小时；</i>
      <br />
      <br />
      <i>周六，12:00–17:00 与 01:00–04:00：15000 卢布/小时；</i>
      <br />
      <i>周六，17:00–01:00：30000 卢布/小时；</i>
      <br />
      <br />
      <i>周日，12:00–17:00：15000 卢布/小时；</i>
      <br />
      <i>周日，17:00–00:00：20000 卢布/小时；</i>
      <br />
      <i>周日，00:00–02:00：10000 卢布/小时。</i>
      <br />
      <br />
      - 最低消费（押金）按以下规则计算：
      <br />
      <br />
      <i>周一–周四，12:00–18:00：10000 卢布/小时；</i>
      <br />
      <i>周一–周四，18:00–00:00：30000 卢布/小时；</i>
      <br />
      <i>周一–周四，00:00–02:00：20000 卢布/小时；</i>
      <br />
      <br />
      <i>周五，12:00–18:00：15000 卢布/小时；</i>
      <br />
      <i>周五，18:00–01:00：40000 卢布/小时；</i>
      <br />
      <i>周五，01:00–04:00：25000 卢布/小时；</i>
      <br />
      <br />
      <i>周六，12:00–17:00：25000 卢布/小时；</i>
      <br />
      <i>周六，17:00–01:00：40000 卢布/小时；</i>
      <br />
      <i>周六，01:00–04:00：25000 卢布/小时；</i>
      <br />
      <br />
      <i>周日，12:00–17:00 与 00:00–02:00：25000 卢布/小时；</i>
      <br />
      <i>周日，17:00–00:00：40000 卢布/小时。</i>
      <br />
      <br />
      最低消费（以及超出最低消费的账单部分）将收取 10% 服务费。
      <br />
      <br />
      预付款：20%。
      <br />
      <br />
      建议至少提前 1 天预订你想要的日期。
      <br />
      <br />
      <b>关于整厅租用「Discopolaroid 大厅」有一个重要说明：</b>
      该选项仅在我们露台不开放的时期提供（因为通往露台的入口正是经过这个大厅）。
      也就是说，租用「Discopolaroid」不包含露台通行。
    </>,
  ],

  bigliving: [
    <>
      <b>「大客厅」</b>
      是我们的主空间与“招牌”大厅。修复后的灰泥装饰、木窗、拼花地板、壁炉——整体以包豪斯的最佳传统呈现，空间感十足，并带着独特的复古气质。
      <br />
      <br />
      平时大厅内摆放 5
      张桌子，但也可整厅租用：必要时我们会带来额外家具，并可为自助/小型宴会布置
      2–3 张高脚鸡尾酒桌。照片里展示了一个布置示例。
      <br />
      <br />
      我们<b>随时可以提前接受预点</b>
      （菜单任意品项），这样你到达时，一切都已准备好并在大客厅等待你。
      <br />
      <br />
      可以自带食物（例如外卖或餐饮服务），但不允许自带酒精和任何饮料。
      <br />
      <br />
      <b>整厅租用时，大客厅的最佳容量为最多 20 人。</b>
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>费用由“租金 + 最低消费（押金）”组成：</b>
    </>,
    <>
      - 租金按以下规则计算：
      <br />
      <br />
      <i>周一–周四，12:00–18:00 与 00:00–02:00：10000 卢布/小时；</i>
      <br />
      <i>周一–周三，18:00–00:00：15000 卢布/小时；</i>
      <br />
      <i>周四，18:00–00:00：20000 卢布/小时；</i>
      <br />
      <br />
      <i>周五，12:00–18:00：10000 卢布/小时；</i>
      <br />
      <i>周五，18:00–01:00：25000 卢布/小时；</i>
      <br />
      <i>周五，01:00–04:00：15000 卢布/小时；</i>
      <br />
      <br />
      <i>周六，12:00–17:00 与 01:00–04:00：15000 卢布/小时；</i>
      <br />
      <i>周六，17:00–01:00：25000 卢布/小时；</i>
      <br />
      <br />
      <i>周日，12:00–17:00：15000 卢布/小时；</i>
      <br />
      <i>周日，17:00–00:00：20000 卢布/小时；</i>
      <br />
      <i>周日，00:00–02:00：10000 卢布/小时。</i>
      <br />
      <br />
      - 最低消费（押金）按以下规则计算：
      <br />
      <br />
      <i>周一–周四，12:00–18:00：10000 卢布/小时；</i>
      <br />
      <i>周一–周四，18:00–00:00：20000 卢布/小时；</i>
      <br />
      <i>周一–周四，00:00–02:00：15000 卢布/小时；</i>
      <br />
      <br />
      <i>周五，12:00–18:00：15000 卢布/小时；</i>
      <br />
      <i>周五，18:00–01:00：35000 卢布/小时；</i>
      <br />
      <i>周五，01:00–04:00：20000 卢布/小时；</i>
      <br />
      <br />
      <i>周六，12:00–17:00：15000 卢布/小时；</i>
      <br />
      <i>周六，17:00–01:00：40000 卢布/小时；</i>
      <br />
      <i>周六，01:00–04:00：20000 卢布/小时；</i>
      <br />
      <br />
      <i>周日，12:00–17:00 与 00:00–02:00：15000 卢布/小时；</i>
      <br />
      <i>周日，17:00–00:00：30000 卢布/小时。</i>
      <br />
      <br />
      最低消费（以及超出最低消费的账单部分）将收取 10% 服务费。
      <br />
      <br />
      预付款：20%。
      <br />
      <br />
      建议至少提前 1 天预订你想要的日期。
    </>,
  ],

  Residence: [
    <>
      <b>整栋公馆</b>
      意味着：在没有外人的情况下，完全沉浸在舒适、复古陈设与创造力的氛围之中。
      <br />
      <br />
      你将拥有两层楼、所有大厅与「私密房间」、（暖季）露台，以及充分的自由。{" "}
      <b>可举办公司活动、婚礼、生日、主题活动与派对、演示/发布等。</b>
      <br />
      <br />
      这是为重视私密性、想要“特别一点”的人准备的独家方案。每一次整栋租用都会单独沟通：考虑所有细节、预点以及宾客的其他需求。
      可以自带食物（例如餐饮服务），但不允许自带酒精和任何饮料。
      <br />
      <br />
      我们也可以协助邀请 DJ
      与艺人、租赁设备（音乐、灯光等），并可提供优秀的布置师、摄影师与摄像师服务。
      如有需要，我们也会提供可靠餐饮团队的联系方式。此外，我们还有额外家具与自助餐桌可用。
      <br />
      <br />
      <b>整栋公馆整租容量：最多 100 人；如果包含露台，最多 150 人。</b>{" "}
      重要说明：露台仅在暖季开放，并且只能运营到 23:00。
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>
        费用由租金与最低消费（押金）组成（取决于具体时间与星期几），将按实际情况单独计算。
      </b>
      <br />
      <br />
      最低消费（以及超出最低消费的账单部分）将收取 10% 服务费。
      <br />
      <br />
      整栋公馆全天整租可享 10% 折扣。
      <br />
      <br />
      预付款：全天整租 50%，非全天整租 30%。
      <br />
      <br />
      预订需至少提前 1 周。
    </>,
  ],
};

export default zh;
